import {DELIVERED_SERVICES_TYPE} from "../Model/Model";
import {CheckCardIcon} from "../../../../components/buttons/IconButtons";
/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    FullStack Developer
 * @Email       kpozos@ibl.mx
 */
const ServicesAccessMethod = ({ row, t }) => {

    return <>
        <div className={'d-sm-inline-block d-md-inline-block'}>
            <div className='card-border-8px background-shades-50 border-full-shades-300'>
                <div className='d-flex align-items-center justify-content-center h-100 m-2'>
                    {(() => {
                        const deliveredType = DELIVERED_SERVICES_TYPE[row.entryAccessMethodId];
                        const IconComponent = deliveredType?.ICON;

                        return (
                            <>
                                {IconComponent && (
                                    <IconComponent className='icon-color-shades-500 w-h-24px' />
                                )}

                                <p className='fs-12px ibl-font-w-600 font-color-shades-700 mx-3 text-capitalize'>
                                    {t(deliveredType?.TRANS)}
                                </p>

                                <CheckCardIcon className='icon-color-success-600 w-h-24px' />
                            </>
                        );
                    })()}
                </div>
            </div>
        </div>
    </>
};

export default ServicesAccessMethod;
